import http from '@/http'

export async function draftPartLookup (params: any[]): Promise<any> {
  const { data } = await http.post('/admin/draft/parts/lookup', params)
  return data
}